// Se llega acá cuando CloudFront o S3 devolvieron error para un /docs/*.
// La distribution tiene custom_error_response 403 y 404 -> /index.html con
// status 200, así que un PDF inaccesible carga la SPA en la URL del documento.
//
// Causa más probable: cookies vencidas. Se reemiten y se reintenta una sola vez.

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { ensureDocsSession } from '../lib/docsSession';

export default function DocFallback() {
  const { search } = useLocation();
  const { getAccessTokenSilently } = useAuth0();
  const [agotado, setAgotado] = useState(false);

  const yaReintento = new URLSearchParams(search).has('r');

  useEffect(() => {
    if (yaReintento) {
      setAgotado(true);
      return;
    }

    let cancelado = false;
    ensureDocsSession(getAccessTokenSilently).then((ok) => {
      if (cancelado) return;
      if (!ok) {
        setAgotado(true);
        return;
      }
      // window.location, no el pathname del router: las rutas de documentos
      // pueden traer doble slash (claves con slash inicial) y acá interesa el
      // path exacto que vio el browser.
      const url = new URL(window.location.href);
      url.searchParams.set('r', '1');
      // replace, no assign: no deja el intento fallido en el historial.
      window.location.replace(url.toString());
    });

    return () => { cancelado = true; };
  }, [yaReintento, getAccessTokenSilently]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md text-center">
        {agotado ? (
          <>
            <div className="text-4xl mb-4">📄</div>
            <h1 className="text-lg font-semibold text-gray-900 mb-2">
              No pudimos abrir el documento
            </h1>
            <p className="text-sm text-gray-600 mb-6">
              Puede que ya no esté disponible, o que tu sesión haya expirado.
              Volvé al portal e intentá de nuevo desde el reporte.
            </p>
            <a
              href="/"
              className="inline-block bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-red-700 transition-colors"
            >
              Ir al portal
            </a>
          </>
        ) : (
          <p className="text-sm text-gray-600">Abriendo el documento…</p>
        )}
      </div>
    </div>
  );
}
